import dayjs from "dayjs";

const formatDate = (iso: string | undefined | null): string =>
	iso ? dayjs(iso).format("DD MMM YYYY") : "";

export const adaptKeyShout = (data: IKeyShout): KeyShout => {
	return {
		id: data.id,
		heading: data.heading,
		content: data.content,
		buttonLink: data.button_link,
		image: data.image,
		appLink: data.app_link,
		modalLink: data.modal_link,
		webview: data.webview,
		feedId: data.feed_id ?? null,
		feed: data.feed ? { uuid: data.feed.uuid, name: data.feed.name } : null,
		published: data.published,
		order: data.ordering,
		createdBy: data.created_by
			? {
					id: data.created_by.id,
					firstName: data.created_by.first_name,
					lastName: data.created_by.last_name
				}
			: undefined,
		createdAt: formatDate(data.created_at),
		updatedAt: formatDate(data.updated_at),
		audienceGroups: data.audience_groups ?? []
	};
};

export const adaptKeyShouts = (data: IKeyShout[]): KeyShout[] => {
	return data.map(adaptKeyShout);
};
